import { useMemo } from 'react';
import type { DateTime } from 'luxon';
import type { PolicyRecord } from '../context/PolicyDetailsContext';
import { HailPerOccurrenceCard } from './HailPerOccurrenceCard';
import { hailPerOccurrenceFigures, termAndPremiumFigures } from './policyFigures';
import { TermAndPremiumCard } from './TermAndPremiumCard';

/**
 * The Policy Details section's top row of cards: "Term and premium", then "Hail per occurrence" on a
 * per-occurrence policy. `now` is the page's shared "now", which the header also reads.
 */
export function PolicyDetailsSection({ policy, now }: { policy: PolicyRecord; now: DateTime }) {
  const termFigures = useMemo(() => termAndPremiumFigures(policy, now), [policy, now]);
  const hailFigures = useMemo(() => hailPerOccurrenceFigures(policy), [policy]);

  return (
    <div className="grid grid-cols-[repeat(auto-fill,minmax(min(290px,100%),1fr))] gap-3">
      <TermAndPremiumCard figures={termFigures} />
      {hailFigures.length ? <HailPerOccurrenceCard figures={hailFigures} /> : null}
    </div>
  );
}
